var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("billing-address")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("companyName"), fancy: "" },
                    model: {
                      value: _vm.address.companyName,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "companyName", $$v)
                      },
                      expression: "address.companyName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      label: _vm.$ct("vatNumber"),
                      fancy: "",
                      disabled: _vm.vatNumberDisabled,
                    },
                    model: {
                      value: _vm.address.vatNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "vatNumber", $$v)
                      },
                      expression: "address.vatNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c("w-input", {
                    class: { error: _vm.shouldShowRequiredError("firstName") },
                    attrs: {
                      label: _vm.$ct("firstName"),
                      fancy: "",
                      required: "",
                    },
                    on: {
                      blur: function ($event) {
                        _vm.focused.firstName = true
                      },
                    },
                    model: {
                      value: _vm.address.firstName,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "firstName", $$v)
                      },
                      expression: "address.firstName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c("w-input", {
                    class: { error: _vm.shouldShowRequiredError("lastName") },
                    attrs: {
                      label: _vm.$ct("lastName"),
                      fancy: "",
                      required: "",
                    },
                    on: {
                      blur: function ($event) {
                        _vm.focused.lastName = true
                      },
                    },
                    model: {
                      value: _vm.address.lastName,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "lastName", $$v)
                      },
                      expression: "address.lastName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    class: { error: _vm.shouldShowRequiredError("address") },
                    attrs: {
                      label: _vm.$ct("address"),
                      fancy: "",
                      required: "",
                    },
                    on: {
                      blur: function ($event) {
                        _vm.focused.address = true
                      },
                    },
                    model: {
                      value: _vm.address.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "address", $$v)
                      },
                      expression: "address.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", lg: "4" } },
                [
                  _c("w-input", {
                    class: { error: _vm.shouldShowRequiredError("postal") },
                    attrs: {
                      label: _vm.$ct("postal"),
                      fancy: "",
                      required: "",
                    },
                    on: {
                      blur: function ($event) {
                        _vm.focused.postal = true
                      },
                    },
                    model: {
                      value: _vm.address.postal,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "postal", $$v)
                      },
                      expression: "address.postal",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6", lg: "8" } },
                [
                  _c("w-input", {
                    class: { error: _vm.shouldShowRequiredError("postal") },
                    attrs: { label: _vm.$ct("place"), fancy: "", required: "" },
                    on: {
                      blur: function ($event) {
                        _vm.focused.place = true
                      },
                    },
                    model: {
                      value: _vm.address.place,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "place", $$v)
                      },
                      expression: "address.place",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-country-code-autocomplete", {
                    class: { error: _vm.shouldShowRequiredError("country") },
                    attrs: {
                      label: _vm.$ct("country"),
                      fancy: "",
                      required: "",
                    },
                    on: {
                      blur: function ($event) {
                        _vm.focused.country = true
                      },
                    },
                    model: {
                      value: _vm.address.country,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "country", $$v)
                      },
                      expression: "address.country",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c("w-input", {
                    class: { error: _vm.shouldShowRequiredError("tel") },
                    attrs: { label: _vm.$ct("tel"), fancy: "", required: "" },
                    on: {
                      blur: function ($event) {
                        _vm.focused.tel = true
                      },
                    },
                    model: {
                      value: _vm.address.tel,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "tel", $$v)
                      },
                      expression: "address.tel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c("w-input", {
                    class: { error: _vm.shouldShowRequiredError("email") },
                    attrs: { label: _vm.$ct("email"), fancy: "", required: "" },
                    on: {
                      blur: function ($event) {
                        _vm.focused.email = true
                      },
                    },
                    model: {
                      value: _vm.address.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.address, "email", $$v)
                      },
                      expression: "address.email",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _vm.cancelButton
            ? _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              )
            : _vm._e(),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isValid, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }